import fromPairs from 'lodash/fromPairs';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import sumBy from 'lodash/sumBy';

import { getProductLabel } from '../../campaign-editor/transform-for-rendering';
import { getProductRowId } from '../change-product-budget/utils';
import { BUDGET_FIELDS_VALUES } from './constants';
import patch from './patch';
import TransferBudgetComment from './TransferBudgetComment';
import TransferBudgetForm from './TransferBudgetForm';

export default {
  label: 'Transfer Budget',
  value: 'Transfer Budget',
  Form: TransferBudgetForm,
  Comment: TransferBudgetComment,
  initialState(campaign, campaignLinesById) {
    const campaignLines = Object.values(campaignLinesById);
    const campaignLinesByProductRowId = groupBy(campaignLines, getProductRowId);

    const roundToTwoDecimals = value => parseFloat(value.toFixed(2));

    return {
      delta: 0,
      productAggregates: mapValues(campaignLinesByProductRowId, lines => {
        const rep = lines[0];

        const values = fromPairs(
          BUDGET_FIELDS_VALUES.map(budgetField => [
            budgetField,
            roundToTwoDecimals(sumBy(lines, budgetField)),
          ]),
        );

        const { product } = rep;
        return {
          label: getProductLabel(product),
          product,
          adjustedFee: rep.adjustedFee / 100 || 0,
          lineIds: lines.map(({ id }) => id),
          oldValues: values,
          newValues: values,
        };
      }),
    };
  },
  patch,
};
